module.exports = __webpack_public_path__ + "static/media/login-graphic.dfa59862.svg";